// What `help` prints at the Terminal command line (#4398, epic #4391). The
// parser (`commands.ts`) stays i18n-free and returns `{ kind: 'help' }`; this
// renders it through `t()`, and reads the keymap from `keymap.ts`'s own
// `SHORTCUTS` table so the help text and the bindings cannot drift apart.
//
// One static `t('terminal.command_help_*')` call per verb line, on purpose:
// `i18n.coverage.test.ts` can only prove a STATIC key resolves, and a help
// screen showing `⟦key⟧` is exactly the failure it exists to catch.

import { t } from '../../i18n';
import { SHORTCUTS } from './keymap';

/** The verb reference, one line per verb (aliases share a line). */
function verbLines(): readonly string[] {
  return [
    t('terminal.command_help_split'),
    t('terminal.command_help_zoom'),
    t('terminal.command_help_close'),
    t('terminal.command_help_filter'),
    t('terminal.command_help_grep'),
    t('terminal.command_help_tail'),
    t('terminal.command_help_follow'),
    t('terminal.command_help_pause'),
    t('terminal.command_help_clear'),
    t('terminal.command_help_open'),
    t('terminal.command_help_workers'),
    t('terminal.command_help_keys'),
    t('terminal.command_help_status'),
    t('terminal.command_help_history'),
    t('terminal.command_help_help'),
  ];
}

/** The keymap section, straight off `SHORTCUTS` — every combo, fallbacks included. */
function keymapLines(): readonly string[] {
  return SHORTCUTS.map((s) => `${s.combos.join(' / ')} — ${t(s.label)}`);
}

/** Every line `help` prints, in order. */
export function commandHelpLines(): readonly string[] {
  return [
    t('terminal.command_help_heading'),
    ...verbLines(),
    t('terminal.command_help_keymap_heading'),
    ...keymapLines(),
    t('terminal.command_help_keymap_note'),
  ];
}
